import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../pages/main.css';

const CompileAndDeployComponent = (props) => {
    const [response, setResponse] = useState('');
    const [_ContractName, set_ContractName] = useState('');
    const [_ContractSymbol, set_ContractSymbol] = useState('');
    const [_TotalSupply, set_TotalSupply] = useState('');
    const [_TokenTransferAddress, set_TokenTransferAddress] = useState('');
    const userAddress = props.userAddress;
    const getLastPaymentRecordIndex = props.getLastPaymentRecordIndex;
    const _selectededNetwork = props._ChainID;
    const navigate = useNavigate();
    const [_Series, set_Series] = useState('');
    const [_OtraInformacion, set_OtraInformacion] = useState('');
    const [_RequisitosLegales, set_RequisitosLegales] = useState('');

    const [_baseuri, set_baseuri] = useState('');
    const [_notrevealeduri, set_notrevealeduri] = useState('');
    const [_contracturi, set_contracturi] = useState('');
    const [_givenMaxSupply, set_givenMaxSupply] = useState('');
    const [errorMessage, setErrorMessage] = useState(""); // State to hold error message
    const [errorMessage1, setErrorMessage1] = useState(""); // State to hold error message
    const [errorMessage2, setErrorMessage2] = useState(""); // State to hold error message
    const [errorMessage3, setErrorMessage3] = useState(""); // State to hold error message
    const [errorMessage4, setErrorMessage4] = useState(""); // State to hold error message
    const [errorMessage5, setErrorMessage5] = useState(""); // State to hold error message
    const [errorMessage6, setErrorMessage6] = useState(""); // State to hold error message

    const [errorMessages, setErrorMessages] = useState({
        _ContractName: '',
        _Series: '',
        _ContractSymbol: '',
        _TotalSupply: '',
        _TokenTransferAddress: '',
        _givenMaxSupply: ''
    });

    const isAnyInputEmpty = () => {
        return (
            !_ContractName ||
            !_Series ||
            !_ContractSymbol ||
            !_TotalSupply ||
            !_TokenTransferAddress ||
            !_givenMaxSupply
        );
    };

    const isButtonDisabled = isAnyInputEmpty();

    useEffect(() => {
        console.log("_ChainID_USEEFFECT : " + _selectededNetwork);
    }, []);

    {/*
    
    ....................................BEFORE EDITS.......................................
    
    const handleCompileAndDeploy = async () => {
        try {
            // Trigger the compilation first
            const compileResponse = await axios.post('https://tokeniza.co.uk/api/compileNFT');
            //http://tokeniza.co.uk/deploy

            console.log("compileResponse : " + compileResponse.data);
            console.log("Compiling...");

            if (compileResponse.data === 'Compilation successful' || compileResponse.data === 'Contracts are already compiled. Move to deployment') {
                console.log("Successfully compiled and now Deploying....");
                setResponse("Deploying & Verifying....");

                console.log("chainID_CLIENT : " + _selectededNetwork);

                // If compilation is successful, trigger the deployment
                const deployResponse = await axios.post('https://tokeniza.co.uk/api/deployNFT', {
                    //http://tokeniza.co.uk/deploy

                    contractName: _ContractName,
                    series: _Series,
                    contractSymbol: _ContractSymbol,
                    totalSupply: _TotalSupply,
                    tokenTransferAddress: _TokenTransferAddress,
                    userAddress: userAddress,
                    otraInformacion: _OtraInformacion,
                    requisitosLegales: _RequisitosLegales,
                    getLastPaymentRecordIndex: Number(getLastPaymentRecordIndex),
                    selectededNetwork: _selectededNetwork,
                    baseuri: _baseuri,
                    notrevealeduri: _notrevealeduri,
                    contracturi: _contracturi,
                    givenMaxSupply: _givenMaxSupply
                });

                if (deployResponse.data === 'Deployment successful') {
                    setResponse('Contract deployed & verified successfully.');
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    navigate(`/nft-dashboard`);
                } else {
                    setResponse(`Error during deployment: ${deployResponse.data}`);
                }
            } else {
                setResponse(`Error during compilation: ${compileResponse.data}`);
            }

        } catch (error) {
            console.error('Error during compilation and deployment:', error.message);
            setResponse(`Error during compilation and deployment: ${error.message}`);
        }
    };*/}

    const handleCompileAndDeploy = async () => {
        try {
            // Trigger the compilation first
            const compileResponse = await axios.post('https://tokeniza.co.uk/api/compileNFT');

            console.log("compileResponse : " + compileResponse.data);
            console.log("Compiling...");

            if (compileResponse.data === 'Compilation successful' || compileResponse.data === 'Contracts are already compiled. Move to deployment') {
                console.log("Successfully compiled and now Deploying....");
                setResponse("Deploying & Verifying....");

                console.log("chainID_CLIENT : " + _selectededNetwork);

                // If compilation is successful, trigger the deployment

                // Check if _baseuri ends with "/"
                const baseuri = _baseuri.endsWith('/') ? _baseuri : _baseuri + '/';

                const deployResponse = await axios.post('https://tokeniza.co.uk/api/deployNFT', {
                    contractName: _ContractName,
                    series: _Series,
                    contractSymbol: _ContractSymbol,
                    totalSupply: _TotalSupply,
                    tokenTransferAddress: _TokenTransferAddress,
                    userAddress: userAddress,
                    otraInformacion: _OtraInformacion,
                    requisitosLegales: _RequisitosLegales,
                    getLastPaymentRecordIndex: Number(getLastPaymentRecordIndex),
                    selectededNetwork: _selectededNetwork,
                    baseuri: baseuri, // Use the modified baseuri
                    notrevealeduri: _notrevealeduri,
                    contracturi: _contracturi,
                    givenMaxSupply: _givenMaxSupply
                });

                if (deployResponse.data === 'Deployment successful') {
                    setResponse('Contract deployed & verified successfully.');
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    navigate(`/nft-dashboard`);
                } else {
                    setResponse(`Error during deployment: ${deployResponse.data}`);
                }
            } else {
                setResponse(`Error during compilation: ${compileResponse.data}`);
            }
        } catch (error) {
            console.error('Error during compilation and deployment:', error.message);
            setResponse(`Error during compilation and deployment: ${error.message}`);
        }
    };

    return (

        <div>
            <div class="header">DEPLOY</div>
            <div class="registerT">Unlock the power of customization and create your unique token here, tailoring it to your preferences and needs with just a few simple clicks.</div>
            <div className='mainDiv'>
                <div>
                    <div>
                        <input
                            className="mintingAmount"
                            type="text"
                            name="_ContractName"
                            placeholder="Contract Name"
                            value={_ContractName}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 10) {
                                    set_ContractName(inputValue);
                                    setErrorMessage1(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage1("Length exceeds maximum allowed (10 characters)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage1 && <div style={{ color: 'red' }}>{errorMessage1}</div>}

                        <input
                            className="mintingAmount"
                            type="text"
                            name="_Series"
                            placeholder="Series"
                            value={_Series}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 10) {
                                    set_Series(inputValue);
                                    setErrorMessage2(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage2("Length exceeds maximum allowed (10 characters)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage2 && <div style={{ color: 'red' }}>{errorMessage2}</div>}

                        <input

                            className="mintingAmount"
                            type="text"
                            name="_ContractSymbol"
                            placeholder="Contract Symbol"
                            value={_ContractSymbol}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 10) {
                                    set_ContractSymbol(inputValue);
                                    setErrorMessage3(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage3("Length exceeds maximum allowed (10 characters)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage3 && <div style={{ color: 'red' }}>{errorMessage3}</div>}
                    </div>
                    <div>
                        <input

                            className="mintingAmount"
                            type="number"
                            name="_TotalSupply"
                            placeholder="Total Supply"
                            value={_TotalSupply}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue <= 20000) {
                                    set_TotalSupply(inputValue);
                                    setErrorMessage5(""); // Clear error message if value is valid
                                } else {
                                    setErrorMessage5("Value exceeds maximum allowed (20000)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage5 && <div style={{ color: 'red' }}>{errorMessage5}</div>}
                    </div>
                    <div>
                        <input

                            className="mintingAmount"
                            type="text"
                            name="_TokenTransferAddress"
                            placeholder="Token Transfer Address"
                            value={_TokenTransferAddress}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (inputValue.length <= 42) {
                                    set_TokenTransferAddress(inputValue);
                                    setErrorMessage4(""); // Clear error message if length is valid
                                } else {
                                    setErrorMessage4("Length exceeds maximum allowed (42 characters)"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage4 && <div style={{ color: 'red' }}>{errorMessage4}</div>}
                    </div>
                    <input name="_OtraInformacion" placeholder='Otra información' value={_OtraInformacion}
                        onChange={event => set_OtraInformacion(event.target.value)}></input>

                    <label class="mintingAmount2" for="multilineInput">Requisitos legales</label>
                    <div></div>
                    <textarea id="multilineInput" name="inputText" rows="70" placeholder="Type your text here..." value={_RequisitosLegales}
                        onChange={event => set_RequisitosLegales(event.target.value)}></textarea>

                    <input name="_baseuri" placeholder='Base URI' value={_baseuri}
                        onChange={event => set_baseuri(event.target.value)}></input>

                    <input name="_notrevealeduri" placeholder='Not revealed URI' value={_notrevealeduri}
                        onChange={event => set_notrevealeduri(event.target.value)}></input>

                    <input name="_contracturi" placeholder='Contract URI' value={_contracturi}
                        onChange={event => set_contracturi(event.target.value)}></input>

                    <div>
                        <input
                            name="givenMaxSupply"
                            placeholder="Max Supply"
                            value={_givenMaxSupply}
                            onChange={event => {
                                const inputValue = event.target.value;
                                if (!isNaN(inputValue) && parseInt(inputValue) <= 20000) {
                                    set_givenMaxSupply(inputValue);
                                    setErrorMessage6(""); // Clear error message if value is valid
                                } else {
                                    setErrorMessage6("Value should not exceed 20,000"); // Set error message
                                }
                            }}
                        />
                        {/* Display error message if it's not empty */}
                        {errorMessage6 && <div style={{ color: 'red' }}>{errorMessage6}</div>}
                    </div>
                </div>

                <button className='inButton' onClick={handleCompileAndDeploy} disabled={isButtonDisabled}>
                    Compile and Deploy Contract
                </button>

                <div className='note'>{response}</div>

            </div>
        </div >
    );
};

export default CompileAndDeployComponent;
